module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"link":"Consulter les tâches à faire"},"en":{"link":"View tasks to do"}}')
  delete Component.options._Ctor
}
